import { Button, Row } from "@commonlibs";
import { spacing } from "ui/config/theme/spacing/spacing";
import clsx from "clsx";
import useTranslate from "ui/locale/hooks/useTranslate";
import { FormScaffoldHeaderProps } from "./FormScaffoldHeader.types";
import Link from "ui/router/components/Link/Link";

const BTN_SIZE = "md";

const FormScaffoldHeader = ({ className, isLoading, isEditing, onCancel, onEdit, link, linkText, ...rest }: FormScaffoldHeaderProps) => {
    const translate = useTranslate();
    return (
        <Row className={clsx("form-scaffold-header", className)} gap={spacing["4"]} {...rest}>
            {link && (
                <Button size={BTN_SIZE} variant="outlined">
                    <Link to={link} target="_blank">
                        {linkText}
                    </Link>
                </Button>
            )}
            {isEditing ? (
                <>
                    <Button size={BTN_SIZE} variant="outlined" onClick={onCancel} disabled={isLoading}>
                        {translate("cancel")}
                    </Button>
                    <Button loading={isLoading} size={BTN_SIZE} type="submit">
                        {translate("saveChanges")}
                    </Button>
                </>
            ) : (
                <Button onClick={onEdit} size={BTN_SIZE} loading={isLoading}>
                    {translate("edit")}
                </Button>
            )}
        </Row>
    );
};

export default FormScaffoldHeader;
